import { render, staticRenderFns } from "./NewsInboundEmail.vue?vue&type=template&id=2eec27a5"
import script from "./NewsInboundEmail.vue?vue&type=script&lang=js"
export * from "./NewsInboundEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports